import React, { FC, useContext } from 'react'
import { ProductsContext } from '../ProductsContext';
import { Link } from 'react-router-dom';
import { PRODUCT_DELTA_LIST } from '../ProductConstants';
import arrowIcon from "../../../../assests/img/right-arrow-icon.svg";

interface CategoryItemProps {
    categoryId: string;
    categoryName: string;
}

const CategoryItem: FC<CategoryItemProps> = ({ categoryId, categoryName }) => {
    const prodContext = useContext<any>(ProductsContext);
    const onCategoryItemClicked = (() => {
        prodContext.resetAttributeData();
        // prodContext.setSelected_Category({ id: categoryId, name: categoryName, });
    })
    return (
        <Link onClick={onCategoryItemClicked} to={`${PRODUCT_DELTA_LIST}/${categoryId}`} className={`tw-ml-5 tw-mt-3 tw-rounded tw-flex-shrink-0 tw-box-border tw-w-[216px] tw-h-14 tw-flex tw-flex-row tw-py-3 tw-px-[19px] tw-items-center tw-justify-start tw-gap-[8px] tw-border-[1px] tw-border-solid tw-border-whitesmoke-400 tw-cursor-pointer hover:tw-bg-[#dee3f6]`}>
            <div key={categoryId} className={`tw-flex-1 tw-relative tw-leading-[19.6px]`}>{categoryName}</div>
            <img className={`tw-relative tw-w-[5px] tw-h-[9px]`} alt="" src={arrowIcon} />
        </Link>
    );
}

export default CategoryItem